import React, { useEffect, useState } from "react";
import { ButtonGroup, Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
// import {
//   useAddReportTypeMutation,
//   useUpdateReportTypeMutation,
// } from "../../Data/services/reportTypeApi";
import {
  useAddPageMutation,
  useUpdatePageMutation,
} from "../../Data/services/pageApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import TextEditor from "../TextEditor/TextEditor";
import ClipLoader from "react-spinners/ClipLoader";
import { Controller, useForm } from "react-hook-form";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import _ from "lodash";

const EditPageModal = ({ handleEditModalClose, editData, refetch }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
    },
  });

  const status = watch("status");

  const filterData = [
    {
      value: 0,
      label: "Blogs",
    },
    {
      value: 1,
      label: "Posts",
    },
    {
      value: 2,
      label: "Announcements",
    },
  ];

  const [rowId, setRowId] = useState("");
  const [value, setValue] = useState(
    "<h1>Terms and Conditions</h1><h2>What is Lorem Ipsum?</h2><p><br></p><p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p > <p><br></p>"
  );
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [sending, setSending] = useState(false);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // console.log(data.business_title);
    console.log(editData);
    if (editData) {
      setRowId(editData.id);
      setTitle(editData.title);
      setUrl(editData.url);
      setValue(editData.content);
    }
  }, [editData, mounted]);

  const handleTitle = (e) => {
    console.log(e.target.value);
    setTitle(e.target.value);
  };

  const handleUrl = (e) => {
    console.log(e.target.value);
    setUrl(e.target.value);
  };

  const handleValueChange = (newText) => {
    setValue(newText);
    // console.log("Updated text:", newText);
  };

  // const handleOrder = (e) => {
  //   console.log(e.target.value);
  //   setOrder(e.target.value);
  // };

  const [addPage, { isLoading: adding }] = useAddPageMutation();
  const [updatePage, { isLoading: updating }] = useUpdatePageMutation();

  const handleSubmit = async (e) => {
    const data = {
      title: title,
      content: value,
      url: url,
    };

    setSending(true);
    try {
      let response;
      if (editData) {
        response = await updatePage({ data, id: rowId });
      } else {
        response = await addPage(data);
      }

      if (response.data.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.data.message);
        handleEditModalClose();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div
          className={cssStyles.modalContainer}
          style={{ minWidth: "90%", minHeight: "90%" }}
        >
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 ">
              {editData ? "Edit Content" : "Add Content"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <label className="text-black">Title</label>
                <Input
                  classes="mt-2 mb-3 bg-white"
                  type="text"
                  name="title"
                  placeholder="Enter Title"
                  value={title}
                  onChange={handleTitle}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <label className="text-black">URL</label>
                <Input
                  classes="mt-2 mb-3 bg-white"
                  type="text"
                  name="url"
                  placeholder="Enter URL"
                  value={url}
                  onChange={handleUrl}
                />
              </Col>
            </Row>

            <label className="text-black">Content</label>
            <TextEditor text={value} onChange={setValue} />

            <Row>
              <Col sm={6} xs={12}>
                <div className="d-flex flex-wrap my-3">
                  <label className="text-black">Category</label>
                  <Controller
                    control={control}
                    name="status"
                    render={({ field: { onChange, value } }) => (
                      // <span style={{ width: "280px" }}>
                      <SelectFieldComponent
                        firstOption={_.isEmpty(value) ? "Select Type" : value}
                        optionsList={filterData}
                        onSelectChange={onChange}
                      />
                      // </span>
                    )}
                  />
                </div>
              </Col>
              <Col sm={6} xs={12}>
                <label className="text-black mt-3 mb-0">
                  Schedule Publication
                </label>
                <Input
                  classes="mt-1 mb-3 bg-white"
                  type="date"
                  name="date"
                  placeholder="Schedule publication"
                  value={title}
                  onChange={handleTitle}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <ButtonGroup className="w-100 gap-2">
                  <Button
                    classes={`mt-3 mb-2 ${"shadow"} `}
                    text={
                      sending ? (
                        <ClipLoader color="#0f0f0f" size="22px" />
                      ) : (
                        "Save Draft"
                      )
                    }
                    // disabled={sending || !title || !value}
                    onClick={() => {
                      // there should be saved in draft mode.
                    }}
                  ></Button>
                  <Button
                    classes={`mt-3 mb-2 ${
                      sending || !title || !value ? "bg-dark-subtle" : "shadow"
                    } `}
                    text={
                      sending ? (
                        <ClipLoader color="#0f0f0f" size="22px" />
                      ) : editData ? (
                        "Update"
                      ) : (
                        "Publish"
                      )
                    }
                    disabled={sending || !title || !value}
                    onClick={handleSubmit}
                  ></Button>
                </ButtonGroup>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditPageModal;
